import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';

import { AuthenticationService } from '@finder/shared/services/authentication/authentication.service';
import { MyPlan } from '@finder/shared/components/my-plans-modal/my-plan.class';
import { KeyringService } from '../keyring/keyring.service';

@Injectable({
    providedIn: 'root'
})
export class MyPlansService {

    modalData: any;
    swid: any;
    isSaving = false;
    saved = false;

    constructor(
        private authenticationService: AuthenticationService,
        private keyringService: KeyringService,
    ) {}

    init(data) {
        this.modalData =  data;
    }

    save(plan: MyPlan, entityId): Observable<any> {
        return this.authenticationService.validateLogin()
            .pipe(
                switchMap(() => this.keyringService.createPersonalScheduleItem(plan, entityId)),
                tap(() => this.saved = true),
                finalize(() => this.isSaving = false)
            );
    }
}
